import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d9ecba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen flex relative overflow-hidden font-inter bg-white" }
const _hoisted_2 = { class: "flex-1 flex items-center justify-center relative z-10 bg-white/95 p-6" }
const _hoisted_3 = { class: "w-full max-w-md space-y-8" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center mb-8\" data-v-68d9ecba><div class=\"flex items-center gap-3\" data-v-68d9ecba><img src=\"http://192.168.1.4/storage/app/public/business/2024-01-18-65a9885147d16.png\" class=\"h-[70px]\" alt=\"Logo\" data-v-68d9ecba></div></div><div class=\"text-center\" data-v-68d9ecba><h2 class=\"text-2xl font-semibold text-gray-800\" data-v-68d9ecba>Escolha uma Organização</h2><p class=\"text-gray-500 text-sm mt-2\" data-v-68d9ecba> Selecione uma organização para acessar o sistema </p></div>", 2)
const _hoisted_6 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-4\" data-v-68d9ecba><div class=\"w-14 h-14 rounded-full bg-gray-200 flex-shrink-0\" data-v-68d9ecba></div><div class=\"flex-1 space-y-2\" data-v-68d9ecba><div class=\"h-4 bg-gray-200 rounded w-3/4\" data-v-68d9ecba></div><div class=\"h-3 bg-gray-200 rounded w-1/2\" data-v-68d9ecba></div></div><div class=\"w-5 h-5 bg-gray-200 rounded flex-shrink-0\" data-v-68d9ecba></div></div>", 1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-center space-y-4"
}
const _hoisted_10 = { class: "bg-red-50 border border-red-200 rounded-xl p-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-600 mb-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8 h-8 mx-auto",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-700 font-medium" }, "Erro ao carregar organizações", -1))
const _hoisted_13 = { class: "text-red-600 text-sm mt-1" }
const _hoisted_14 = {
  key: 2,
  class: "text-center space-y-4"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-gray-50 border border-gray-200 rounded-xl p-6\" data-v-68d9ecba><div class=\"text-gray-400 mb-3\" data-v-68d9ecba><svg class=\"w-12 h-12 mx-auto\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-68d9ecba><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4\" data-v-68d9ecba></path></svg></div><p class=\"text-gray-700 font-medium\" data-v-68d9ecba>Nenhuma organização encontrada</p><p class=\"text-gray-500 text-sm mt-1\" data-v-68d9ecba> Entre em contato com o administrador </p></div>", 1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex items-center gap-4" }
const _hoisted_20 = { class: "flex-1 min-w-0" }
const _hoisted_21 = { class: "font-semibold text-gray-800 text-lg truncate" }
const _hoisted_22 = {
  key: 0,
  class: "text-gray-500 text-xs mt-1"
}
const _hoisted_23 = {
  key: 1,
  class: "text-gray-400 text-xs mt-1"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 group-hover:text-primary transition-colors transform group-hover:translate-x-1" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "w-5 h-5",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 5l7 7-7 7"
      })
    ])
  ])
], -1))
const _hoisted_25 = { class: "flex items-center justify-between pt-6 border-t border-gray-200" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_28 = { class: "flex gap-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })
], -1))

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axiosClient from '@/api/axios'
import { setOrganization, removeAuthCookies, removeStorageItems } from '@/utils/auth'
import { useToast } from 'vue-toastification'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOrganizationsView',
  setup(__props) {

const router = useRouter()
const toast = useToast()

// Reactive data
const organizations = ref<any[]>([])
const loading = ref(false)
const error = ref<string | null>(null)

// Load organizations on component mount
const loadOrganizations = async () => {
    loading.value = true
    error.value = null

    try {
        const response = await axiosClient.get('/organizations')
        organizations.value = response.data.data || response.data || []
    } catch (err: any) {
        console.error('Error loading organizations:', err)
        error.value = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || 'Erro ao carregar organizações'
    } finally {
        loading.value = false
    }
}

// Confirm organization selection
const handleChooseOrganization = async (selectedOrg: any) => {
    try {
        setOrganization(selectedOrg)
        toast.success(`Organização "${selectedOrg.name}" selecionada`)
        // Force reload to clean state and apply organization context globally
        window.location.href = '/'
    } catch (err) {
        console.error('Error confirming organization:', err)
        error.value = 'Erro ao selecionar organização'
    }
}

// Go back to login
const goBack = () => {
    router.push({ name: 'login' })
}

// Logout
const logout = () => {
    removeAuthCookies()
    removeStorageItems()
}

const formatDocument = (document: string): string => {
    if (!document) return ''

    // Remove all non-numeric characters
    const cleanDoc = document.replace(/\D/g, '')

    // Format based on length (CPF or CNPJ)
    if (cleanDoc.length === 11) {
        return cleanDoc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else if (cleanDoc.length === 14) {
        return cleanDoc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }

    return document
}

// Lifecycle
onMounted(() => {
    loadOrganizations()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "bg-white border-2 border-gray-200 rounded-xl p-4 animate-pulse"
                }, _hoisted_8)
              }), 64))
            ]))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(error.value), 1),
                  _createElementVNode("button", {
                    onClick: loadOrganizations,
                    class: "mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
                  }, " Tentar Novamente ")
                ])
              ]))
            : (organizations.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (org) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: org.id,
                      onClick: ($event: any) => (handleChooseOrganization(org)),
                      class: "group relative bg-white border-2 border-gray-200 rounded-xl p-4 hover:border-primary hover:shadow-lg transition-all duration-300 cursor-pointer"
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(org.name), 1),
                          (org.document)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(formatDocument(org.document)), 1))
                            : _createCommentVNode("", true),
                          (org.email)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(org.email), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_24
                      ])
                    ], 8, _hoisted_18))
                  }), 128))
                ])),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            onClick: goBack,
            class: "px-6 py-2.5 text-gray-600 hover:text-gray-800 font-medium transition-colors flex items-center gap-2 hover:bg-gray-50 rounded-lg",
            disabled: loading.value
          }, [
            _hoisted_27,
            _createTextVNode(" Voltar ")
          ], 8, _hoisted_26),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {logout(); _ctx.$router.push({ name: 'login' })}),
              class: "px-6 py-2.5 bg-white text-red-500 font-medium rounded-lg hover:bg-red-600 focus:outline-none border-2 border-red-500 transition-all duration-200 flex items-center gap-2 hover:text-white hover:border-white",
              disabled: loading.value
            }, [
              _hoisted_30,
              _createTextVNode(" Sair ")
            ], 8, _hoisted_29)
          ])
        ])
      ])
    ])
  ]))
}
}

})